export default __webpack_public_path__ + "static/log-axis-dc58c38f22350d4c0cc00e888fa5486a.png";